import { useState } from 'react';
import { PLATFORM_NAME } from '@enums';
import { useStore } from './useStore';

export const useInstall = () => {
    const store = useStore();
    const [loading, setLoading] = useState(false);

    const { shopDomain, companyName, isShopify, isBigCommerce } = store.accountsStore;
    const { getEcommerceRedirect } = store.authStore;

    const install = async () => {
        setLoading(true);

        if (isShopify) {
            await getEcommerceRedirect(PLATFORM_NAME.SHOPIFY, {
                shop: shopDomain,
                token_type: 'offline',
                companyName
            });
        }

        if (isBigCommerce) {
            await getEcommerceRedirect(PLATFORM_NAME.BIGCOMMERCE, { companyName });
        }

        const { error } = store;

        if (error) {
            setLoading(false);
        }
    };

    return { install, loading };
};
